import React from 'react'
import {useSpendBenchmarksTracking} from '../hooks/useSpendBenchmarksTracking'

interface HeroSectionProps {
  hasPdf: boolean
}

const HeroSection: React.FC<HeroSectionProps> = ({hasPdf}) => {
  const {trackClick} = useSpendBenchmarksTracking()

  return (
    <header className="hero dark">
      <div className="wrap">
        <div className="tagrow">
          <span className="tag neon">2026 EUROPEAN SAAS &amp; AI SPENDING REPORT</span>
        </div>
        <h1 className="hero-title">
          How European companies <span className="neon">actually spend</span> on software.
        </h1>
        <p className="hero-sub" style={{maxWidth: 500}}>
          Based on €302M in company card spend across Europe (Jan 2024–May 2026).
        </p>
        {hasPdf && (
          <div className="hero-cta">
            <a
              className="btn btn-on-dark btn-lg"
              href="#download"
              onClick={() => trackClick('hero_download_report_button')}
            >
              DOWNLOAD FULL REPORT
            </a>
          </div>
        )}
        <div className="three-stats">
          <div className="stat">
            <span className="num mono-num">
              52.3<span style={{fontSize: '0.55em'}}>%</span>
            </span>
            <div className="label">use paid AI tools</div>
          </div>
          <div className="stat">
            <span className="num mono-num">
              +309<span style={{fontSize: '0.55em'}}>%</span>
            </span>
            <div className="label">AI spending growth</div>
          </div>
          <div className="stat">
            <span className="num mono-num">
              €302<span style={{fontSize: '0.55em'}}>M</span>
            </span>
            <div className="label">in SaaS spend analysed</div>
          </div>
        </div>
        <div className="hero-methodology">
          <div className="left">
            Based on real card transactions, Jan 2024-May 2026. <em>20,088 vendors. 19 categories. No estimates.</em>
          </div>
        </div>
      </div>
    </header>
  )
}

export default HeroSection
